import type { PublicSlotKey } from '@/apilib';
import type { DebugLayoutPublicApi } from './api';

export const DebugLayoutApiKey: PublicSlotKey<DebugLayoutPublicApi> = {
  name: 'DebugLayoutApi',
  public: true,
};
